import React from 'react';
import PropTypes from 'prop-types';

function IconSuccess({ size = 16, color = 'black', className, style }) {
  return (
    <svg className={className} style={style} width={size} height={size} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M13.6667 5L6.33333 12.3333L3 9" stroke={color} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  )
}

IconSuccess.propTypes = {
  size: PropTypes.number,
  color: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.object
}

export default IconSuccess;
